var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiJobRunningAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-pipeline-maintenance",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-pipeline-maintenance:not(.animated) .animable {opacity: 0;}svg#freepik_stories-pipeline-maintenance.animated #freepik--background-complete--inject-743 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight,6s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-pipeline-maintenance.animated #freepik--Shadow--inject-743 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-pipeline-maintenance.animated #freepik--Toolbox--inject-743 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-pipeline-maintenance.animated #freepik--character-1--inject-743 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-pipeline-maintenance.animated #freepik--Pipeline--inject-743 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn,3s Infinite  linear heartbeat;animation-delay: 0s,1s;}svg#freepik_stories-pipeline-maintenance.animated #freepik--character-2--inject-743 {animation: 3.2s 1 forwards ease-out lightSpeedLeft;animation-delay: 0s;}            @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-743",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "elpz4yei56hs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.34px 398.615px"
    },
    id: "elurymne8v24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.875px 401.335px"
    },
    id: "el0ge08d6igvru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.185px 389.335px"
    },
    id: "elpc4p681v48j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.055px 391.015px"
    },
    id: "elhcaspslv5j8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.725px 391.015px"
    },
    id: "eln14tnj4gmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.31px 395.235px"
    },
    id: "el1tjdkcaphnv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "ellbvroh2czp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "elqdtg01sv1bn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.58,
    y: 159.18,
    width: 351.78,
    height: 15,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "247.47px 166.68px"
    },
    id: "elds9e9cu20b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.37,
    y: 157.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "422.09px 166.685px"
    },
    id: "elowf2sw2u0fa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.11,
    y: 157.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "305.83px 166.685px"
    },
    id: "el5c0590xr7pv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.85,
    y: 157.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "189.57px 166.685px"
    },
    id: "elrp5vfzp9fs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.58,
    y: 157.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "73.3px 166.685px"
    },
    id: "el1yrxn1vd72",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.46,
    y: 157.6,
    width: 23.62,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "365.27px 166.685px"
    },
    id: "elfw113g4vsxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.29,
    y: 135.18,
    width: 3.96,
    height: 24.79,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "365.27px 147.575px"
    },
    id: "el5o0evjamxdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el797y48c2la"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 365.27,
    cy: 133.7,
    r: 10.12,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "365.27px 133.7px",
      transform: "rotate(-45deg)"
    },
    className: "animable",
    id: "el3inpsx0wj7h"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M372.46,133.7a7.19,7.19,0,1,1-7.19-7.2A7.19,7.19,0,0,1,372.46,133.7Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "365.27px 133.69px"
    },
    id: "elb243eflbqeh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.58,
    y: 189.18,
    width: 351.78,
    height: 15,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "247.47px 196.68px"
    },
    id: "el2puib985v45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.37,
    y: 187.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "422.09px 196.685px"
    },
    id: "elryjh0drfcne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.11,
    y: 187.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "305.83px 196.685px"
    },
    id: "elgiskyb1pndu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.85,
    y: 187.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "189.57px 196.685px"
    },
    id: "elk2mjqbkcax",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.58,
    y: 187.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "73.3px 196.685px"
    },
    id: "elf6ahfwvlnv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.58,220.18v15H322.19A23.81,23.81,0,0,1,346,259V381.61h15V258.79a38.61,38.61,0,0,0-38.61-38.61Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "216.29px 300.895px"
    },
    id: "eljt7uevu88q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.11,
    y: 218.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "305.83px 227.685px"
    },
    id: "elrtc7wvtvop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.85,
    y: 218.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "189.57px 227.685px"
    },
    id: "elpi4e8q3vu1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.58,
    y: 218.6,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "73.3px 227.685px"
    },
    id: "elerz7tsnpnvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk78n3chuwsl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.78,
    y: 371.26,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "353.5px 380.345px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elattvff6qcs9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj29zfdfx1ke"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.78,
    y: 265.99,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "353.5px 275.075px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "eldrzf1af2648"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-743",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-743",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Toolbox--inject-743",
    className: "animable",
    style: {
      transformOrigin: "279.25px 406.265px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.49,394.56h11.74a3.69,3.69,0,0,1,3.69,3.69v3a0,0,0,0,1,0,0H268.8a0,0,0,0,1,0,0v-3A3.69,3.69,0,0,1,272.49,394.56Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      transformOrigin: "278.36px 397.905px"
    },
    id: "elp1xbwz2vanl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.23,398.62h42a2.35,2.35,0,0,1,2.35,2.35v17a0,0,0,0,1,0,0H255.88a0,0,0,0,1,0,0V401A2.35,2.35,0,0,1,258.23,398.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "279.23px 408.295px"
    },
    id: "el9ina5cnmxq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo57j7uzcvae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.23,398.62h23.06a2.35,2.35,0,0,1,2.35,2.35v17a0,0,0,0,1,0,0H255.88a0,0,0,0,1,0,0V401A2.35,2.35,0,0,1,258.23,398.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "269.76px 408.295px"
    },
    className: "animable",
    id: "eluwlniikip6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1fxnowd39fm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.88,
    y: 404.33,
    width: 46.74,
    height: 1.01,
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "279.25px 404.835px"
    },
    className: "animable",
    id: "elepwry6rjaxe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-743",
    className: "animable",
    style: {
      transformOrigin: "108.964px 303.265px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.64,217l4.25-5s-1-4.14,0-5.14,3-4.24,5.08-4.7,6.67,4.36,5.05,6.7-3,4.49-4.2,4.51h-1.18l-5.34,5.18Z",
    style: {
      fill: "rgb(228, 137, 123)",
      transformOrigin: "143px 210.34px"
    },
    id: "eltvn6shn6zu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,227.1c5.63.76,14.73,2.11,18.69-.54s13.11-13.16,13.11-13.16l4.89,2.79s-11.87,18.17-15.23,19.57-23,1.36-23,1.36Z",
    style: {
      fill: "#20E290",
      transformOrigin: "123.575px 225.26px"
    },
    id: "eld5z4xdgvld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmk02yj5r6wh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.66,216.19s-11.87,18.17-15.23,19.56c-1.83.77-8.5,1.11-14.19,1.25-4.75.14-8.81.12-8.81.12l1.12-7.27.42-2.75c5.63.76,14.73,2.12,18.69-.54s13.11-13.15,13.11-13.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "123.545px 225.265px"
    },
    className: "animable",
    id: "elvb9q1qt246"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el77pteb100it"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.24,237c-4.75.14-8.81.12-8.81.12l1.12-7.27A22.44,22.44,0,0,1,113.24,237Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "108.835px 233.485px"
    },
    className: "animable",
    id: "el8ghkdx1g1ww"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.78,213.4a8.07,8.07,0,0,0-4.27,7.36c-.08,5.52-3.05,13.43-2.26,19s6.59,4.87,8.43-2.15S78.25,226,79,221.8a9.82,9.82,0,0,1,4.46-6.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "77.2882px 228.433px"
    },
    id: "elbavpp9yu929",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.77 410.27 127.23 411.25 124.96 403.7 122.89 396.76 129.28 394.53 131.13 402.87 132.77 410.27",
    style: {
      fill: "rgb(228, 137, 123)",
      transformOrigin: "127.83px 402.89px"
    },
    id: "elan4d91im8r5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els0artyiidp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.16 403.04 124.99 403.85 122.9 396.84 129.28 394.57 131.16 403.04",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "127.03px 399.21px"
    },
    className: "animable",
    id: "elfzjcztdwbed"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "95.78 412.83 90.16 412.83 89.23 404.9 88.39 397.67 95.07 396.56 95.45 405.17 95.78 412.83",
    style: {
      fill: "rgb(228, 137, 123)",
      transformOrigin: "92.085px 404.695px"
    },
    id: "el2xklu515byc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcxvq3r7p5zu"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "95.45 405.24 89.23 404.97 88.39 397.7 95.07 396.58 95.45 405.24",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "91.92px 400.91px"
    },
    className: "animable",
    id: "elyfr8qdajrns"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,398.64l-9.11,1.61c-9.19-22.9-15.73-42-20.34-57.89-2.49-8.56-4.57-16.17-6-22.92l.27,24.93v56.16h-9c-22.5-107.17-6.56-131.6-6.56-131.6l26.92-4.48a123.88,123.88,0,0,1,2.26,15.12l1.21,8.93,10.52,54.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.571px 332.49px"
    },
    id: "elz1yfkqy3idj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84,409c0-.59,7.23-.13,7.23-.13s4.44,4.52,8.76,5.54,1.9,3.6-2.92,3.6H90C86.56,418,88.7,415.08,88.84,409Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.566px 413.355px"
    },
    id: "elydx6da8tgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,410.71a9.07,9.07,0,0,1-3-.91.18.18,0,0,1-.07-.05h0s0,0,0,0a.2.2,0,0,1,0-.15c0-.07.63-1.75,1.61-2.16a1.14,1.14,0,0,1,.94,0c.32.16.48.36.47.61s-.54.76-1.12,1.07a3,3,0,0,1,1.62.18.77.77,0,0,1,.38.49.69.69,0,0,1-.17.77A1,1,0,0,1,99.87,410.71Zm-2.33-1c1.06.45,2.38.85,2.73.57,0,0,.12-.1,0-.39a.4.4,0,0,0-.2-.25A4.72,4.72,0,0,0,97.54,409.68Zm1.29-2a.75.75,0,0,0-.29.06,3.16,3.16,0,0,0-1.24,1.55c1.07-.4,2.1-1,2.12-1.29,0-.1-.16-.2-.26-.24A.8.8,0,0,0,98.83,407.69Z",
    style: {
      fill: "#20E290",
      transformOrigin: "98.7687px 409.028px"
    },
    id: "el33oio36azly",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.74,409c0-.59,7.23-.13,7.23-.13s4.44,4.52,8.75,5.54,1.91,3.6-2.92,3.6H126.88C123.45,418,125.59,415.08,125.74,409Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "134.455px 413.355px"
    },
    id: "elogaier53ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.77,410.71a9.13,9.13,0,0,1-3-.91l-.06-.05h0l0,0a.19.19,0,0,1,0-.15c0-.07.63-1.75,1.61-2.16a1.12,1.12,0,0,1,.93,0c.33.16.49.36.48.61s-.54.76-1.13,1.07a3,3,0,0,1,1.62.18.75.75,0,0,1,.39.49.69.69,0,0,1-.18.77A1,1,0,0,1,136.77,410.71Zm-2.33-1c1.06.45,2.38.85,2.72.57,0,0,.12-.1.05-.39a.45.45,0,0,0-.21-.25A4.69,4.69,0,0,0,134.44,409.68Zm1.29-2a.8.8,0,0,0-.3.06,3.2,3.2,0,0,0-1.23,1.55c1.06-.4,2.1-1,2.12-1.29,0-.1-.16-.2-.26-.24A.8.8,0,0,0,135.73,407.69Z",
    style: {
      fill: "#20E290",
      transformOrigin: "135.677px 409.028px"
    },
    id: "elw5206bo3mff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj2vzlth5qk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.23,342.36c-2.49-8.56-4.43-16.17-5.92-22.92a211.09,211.09,0,0,1,1.74-23.91S102,326.37,102.23,342.36Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "99.27px 318.945px"
    },
    className: "animable",
    id: "eld31tilx62zw"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "88.87 273.31 102.99 272.06 102.99 267.48 88.87 268.7 88.87 273.31",
    id: "el28annmcz47n",
    className: "animable",
    style: {
      transformOrigin: "95.93px 270.395px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.63 268.81 80.54 269.42 79.91 274.11 87.63 273.42 87.63 268.81",
    id: "el8lzz9yiky6h",
    className: "animable",
    style: {
      transformOrigin: "83.77px 271.46px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.07 267.39 104.07 271.97 107.24 271.69 107.24 267.12 104.07 267.39",
    id: "elomzwo7qt7k",
    className: "animable",
    style: {
      transformOrigin: "105.655px 269.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.26,267.91a1.67,1.67,0,0,0-1.26-.43l-3.34.29a1.65,1.65,0,0,0-1.51,1.65v2.13a1.65,1.65,0,0,0,.54,1.22,1.61,1.61,0,0,0,1.12.44H95l3.34-.29a1.65,1.65,0,0,0,1.51-1.65v-2.12A1.69,1.69,0,0,0,99.26,267.91Zm-1.05,4.15-3.33.29a.79.79,0,0,1-.62-.21.81.81,0,0,1-.26-.59v-2.13a.81.81,0,0,1,.74-.8l3.33-.28h.07a.83.83,0,0,1,.54.21.81.81,0,0,1,.26.6v.32l-.13,0-.93.07a.57.57,0,0,0-.52.61.56.56,0,0,0,.61.52l.93-.07h0v.7A.8.8,0,0,1,98.21,272.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "96.5px 270.342px"
    },
    id: "eljw0z9fc1wsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.24,241.1c1,3.3,1.82,6.16,2.46,8.71a94.78,94.78,0,0,1,2.84,19.61l26.7-2.3c1.07-18.81.6-29.15.11-34.32-.53-5.51-1.38-5.71-1.38-5.71s-6-.58-11.17-.54a84.64,84.64,0,0,0-12,1.26,78.16,78.16,0,0,0-8.52,1.91A2.52,2.52,0,0,0,72.58,233c.29.85.56,1.66.82,2.46C74.08,237.44,74.68,239.34,75.24,241.1Z",
    style: {
      fill: "#20E290",
      transformOrigin: "90.1597px 247.984px"
    },
    id: "elzx2ahaxa11l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela0hhrv7rw1s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.58,233c.29.84.56,1.66.82,2.46.08.22.15.44.23.65,0,0,0,0,0,0,.3,1,.61,1.91.9,2.8l.69,2.21c.75,2.39,1.38,4.54,1.9,6.51h0c.19.76.38,1.5.56,2.21l.24.94A83.82,83.82,0,0,1,80,262.91c.22,2.11.37,4.22.52,6.51l26.7-2.29c1.07-18.82.59-29.15.1-34.32-.54-5.51-1.38-5.71-1.38-5.71s-4.73-.47-9.44-.53H94.8c-.48,0-1,0-1.46.07s-1.22.06-1.83.11a78.55,78.55,0,0,0-8.38,1l-.31.05-1.69.3c-2.3.44-4.58,1-6.84,1.61A2.53,2.53,0,0,0,72.58,233Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "90.148px 247.995px"
    },
    className: "animable",
    id: "el1b7diy2nhgh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.57,232.25c-6.23-.8-8.1-3.46-8.1-3.46,4-3.73.67-10.19.67-10.19l7.5,1.4a21.33,21.33,0,0,0-.29,3.16c-.06,4.55,2,4.59,2,4.59C94.66,230.22,91.57,232.25,91.57,232.25Z",
    style: {
      fill: "rgb(228, 137, 123)",
      transformOrigin: "88.5718px 225.425px"
    },
    id: "elfag9z7asmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrvq7kae9n9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.64,220a21.33,21.33,0,0,0-.29,3.16,8.35,8.35,0,0,1-7.21-4.56Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "87.89px 220.88px"
    },
    className: "animable",
    id: "eleiq3x79nb0r"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "109.36 268.81 97.36 270.13 96.02 265.57 95.54 270.13 79.01 270.99 79.37 264.19 79.62 259.48 79.48 259.07 78.28 255.63 76.4 250.21 75.51 241.85 74.15 229.22 76.92 228.54 79.67 227.88 81.7 227.4 93.67 237.88 95.54 225.43 97.42 225.66 100.42 226.01 104.75 226.54 108.84 242.29 108.22 256.06 107.98 261.45 107.89 263.5 109.36 268.81",
    style: {
      fill: "#20E290",
      transformOrigin: "91.755px 248.21px"
    },
    id: "elr8irqmt52je",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz7qbvklvdim"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.22,256.06l-.24,5.4-28.61,2.72.25-4.7-.14-.4,8.3-.87c-.22-3.73-.9-10.21-3-15.19a114.71,114.71,0,0,0-7.85-14.47l2.75-.66a53.15,53.15,0,0,1,7,12.63,150.79,150.79,0,0,1,4.6,17.32l11.36-1.19a77.24,77.24,0,0,0-.35-15.93c-.78-5.08-3.2-11.26-4.85-15.06l3,.36c1.82,3.92,4.15,9.73,4.61,14.65a119.74,119.74,0,0,1,.25,15.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "92.575px 244.92px"
    },
    className: "animable",
    id: "elk6i5xfgor1j"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6si9m1q6nqu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.28,255.64l-1.88-5.43-.89-8.35a7.27,7.27,0,0,1,1.41-.36S80.16,249.85,78.28,255.64Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "77.1883px 248.57px"
    },
    className: "animable",
    id: "ell2hztgrthso"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97,207.37s3.11-11.74-8-12.45c-14.32-.9-18.74,19.8-4.76,22.9S97,207.37,97,207.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.5667px 206.586px"
    },
    id: "el1p16ppunii6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,217c-.06.22-.12.44-.18.64a5.91,5.91,0,0,1-6,4.35,10,10,0,0,1-1.43-.05l-1-.13C77.21,220,76.66,199.62,87.5,199c6.51-.36,8.8,3,9.65,9.71A23,23,0,0,1,97,217Z",
    style: {
      fill: "rgb(228, 137, 123)",
      transformOrigin: "88.567px 210.486px"
    },
    id: "elj1h42zosnin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.91,208.6a14,14,0,0,0,2,2.6,1.79,1.79,0,0,1-1.68.83Z",
    style: {
      fill: "rgb(222, 87, 83)",
      transformOrigin: "93.91px 210.319px"
    },
    id: "elfiq0oh8oyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.89,208.29c0,.53-.21,1-.57,1s-.68-.39-.72-.92.22-1,.57-1S88.85,207.75,88.89,208.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.243px 208.33px"
    },
    id: "eln281f3jzx9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,207.41l1.12-.55S88.65,207.88,88,207.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.56px 207.197px"
    },
    id: "elx9b7yxn4rm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54,207.65c0,.54-.22,1-.57,1s-.68-.38-.73-.91.22-1,.57-1S95.49,207.12,95.54,207.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.887px 207.695px"
    },
    id: "elpdii3snm1le",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.67,206.77l1.12-.54S95.29,207.25,94.67,206.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "95.23px 206.564px"
    },
    id: "elmvcwbkyf6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.58,203.79a3.39,3.39,0,0,0-2.77,1.14",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.72468px",
      transformOrigin: "87.195px 204.356px"
    },
    id: "el9ezjru9z5cf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.31,203.25a3,3,0,0,1,2.62.4",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.72468px",
      transformOrigin: "94.62px 203.38px"
    },
    id: "eldteskxepv4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,210.4s2.75-5.52,2.07-9.63c0,0,12.63-6,14,7.09,0,0,.63-11.71-10.6-11.36s-10.27,16.75-4.22,21.32C82.2,217.82,79.27,213.86,81,210.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "87.449px 207.156px"
    },
    id: "elp58c47sw81",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.11,211.72a2.86,2.86,0,0,0-3.22-2.44c-2,.33-2.75,4.53,2.33,5.25C82,214.63,82.32,213.91,82.11,211.72Z",
    style: {
      fill: "rgb(228, 137, 123)",
      transformOrigin: "79.7695px 211.896px"
    },
    id: "elbn4jr0usb8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.81,213.23a3.32,3.32,0,0,0,3.1,2.25",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      transformOrigin: "91.36px 214.355px"
    },
    id: "elj9ee1l3j00e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,208.9a2.68,2.68,0,1,1-2.67-2.67A2.67,2.67,0,0,1,92,208.9Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      transformOrigin: "89.32px 208.91px"
    },
    id: "el0av4nehedcn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,207.83a2.67,2.67,0,1,1-2.67-2.68A2.66,2.66,0,0,1,99,207.83Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      transformOrigin: "96.33px 207.82px"
    },
    id: "el6lyjd0k2wxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,208.34s1-1.14,1.74-.24",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      transformOrigin: "92.87px 208.047px"
    },
    id: "elwvqm24nf8b8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.66,
    y1: 208.9,
    x2: 80.78,
    y2: 209.31,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      transformOrigin: "83.72px 209.105px"
    },
    id: "el4qggxyowjzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.08,195.61a18,18,0,0,1,8.23,1.7c3.55,1.93,3.72,4.89,3.72,4.89l-1.24-.46-2.48-2a4.2,4.2,0,0,1,.5,2S93,200.12,92,199.85a2.25,2.25,0,0,1-.59,2.35,3.82,3.82,0,0,0-1.44-2.11s.19.93-1.67,2.11a2.66,2.66,0,0,0-1.06-2.28s-.89,1.69-2.11,1.94c0,0,.91-.84.73-1.35a6.85,6.85,0,0,1-3.64,1.69C80.14,202.37,77.43,198.06,85.08,195.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.5155px 198.903px"
    },
    id: "ell3s19i2o81c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,202.58s4.27,17.89,13.24,19.75L94,221.8s-4.77.08-8.1-5.26-5.6-14.24-5.6-14.24Z",
    id: "el3zter778vxo",
    className: "animable",
    style: {
      transformOrigin: "86.5px 212.315px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.46,199.34C95,204.85,83.29,200.83,79.15,204s-3.48,6-3.48,6.05c-2.89.89-1.32-3.86-1.32-3.86-3.06-9.31,2.6-14.68,11.29-15.7,8.14-1,10.38,7.24,10.38,7.24Z",
    style: {
      fill: "#20E290",
      transformOrigin: "86.4855px 200.283px"
    },
    id: "elh16bopnb3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellp520ivkoy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,197.68c-1.83,3.25-13.28,2.41-17.56,3.85s-4.11,4.61-4.11,4.61c-3.06-9.31,2.6-14.68,11.29-15.7C93.78,189.48,96,197.68,96,197.68Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "84.7455px 198.251px"
    },
    className: "animable",
    id: "el71rys8lji0w"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.63,192.59c3.46-1.26,7.32,1.67,8.83,3.8s4.66,1.34,4.72-1-2.12-6.87-2.12-6.87-14.33-.26-16.22,7.77A8.81,8.81,0,0,1,79.63,192.59Z",
    style: {
      fill: "#20E290",
      transformOrigin: "84.0106px 193.076px"
    },
    id: "elmo9kt7a8prc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.21,222.4a5,5,0,0,1,2.62-1.48,4,4,0,0,1,2.22,0,3.39,3.39,0,0,1-2.18,1.67A2.8,2.8,0,0,1,90.21,222.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "92.63px 221.801px"
    },
    id: "elmka4gehh3sd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.77 226.56 88.9 229.03 91.36 231.31 91.95 228.93 91.64 224.98 95.7 226.56 97.03 231.7 94.62 230.32 92.82 235.76 87.63 232.25 86.49 234.47 81.7 228.54 83.77 226.56",
    style: {
      fill: "#20E290",
      transformOrigin: "89.365px 230.37px"
    },
    id: "elx51u3lninw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln2hej119ow"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "81.7 228.54 86.49 234.47 87.63 232.25 92.82 235.76 94.62 230.32 97.03 231.7 95.7 226.56 91.64 224.98 91.95 228.93 91.36 231.31 88.9 229.03 83.77 226.56 81.7 228.54",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      isolation: "isolate",
      transformOrigin: "89.365px 230.37px"
    },
    className: "animable",
    id: "el5tb9gx52csh"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3g3u2t972mf"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "86.49 234.47 87.63 232.25 92.82 235.76 87.89 230.37 86.49 234.47",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "89.655px 233.065px"
    },
    className: "animable",
    id: "el8z333biabmx"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eleu5ordetd0w"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "92.82 235.76 94.62 230.32 97.03 231.7 94.23 228.28 92.82 235.76",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "94.925px 232.02px"
    },
    className: "animable",
    id: "elt6emkuedm3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.42,249s-.94,14.94,12.42,14c11.68-.78,23.59-40.53,26.38-50.46a3.05,3.05,0,0,1,2.95-2.22H149",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "127.203px 236.681px"
    },
    id: "elf877xyf46mh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.89 250.19 94.88 250.19 97 229.84 110.02 229.84 107.89 250.19",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "102.45px 240.015px"
    },
    id: "elctmbfqhl69l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elms4kipcmlxb"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "97.8 250.19 94.88 250.19 97 229.84 99.92 229.84 97.8 250.19",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "97.4px 240.015px"
    },
    className: "animable",
    id: "el6x5jjoi7tg3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.06,210.38a1.08,1.08,0,1,1-1.08-1.07A1.08,1.08,0,0,1,150.06,210.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "148.98px 210.39px"
    },
    id: "el381ntcle5v6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.89,251.79,92,249s.22-2.3.67-2.77,7.22-2.49,8.62-2.37,1.65,5.14.33,6.46-6.72,2.44-7.12,2L90.21,255Z",
    style: {
      fill: "rgb(228, 137, 123)",
      transformOrigin: "95.1883px 249.427px"
    },
    id: "el1t484lnu436",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94,230.7c-3.84,2.05-8.39,31.12-2.66,35.82S92.82,254.3,92.82,254.3l-2.78-6s-10.27,8.67-12.89,7.2,0-9.69,0-9.69a29,29,0,0,0,0-8.54A9.68,9.68,0,0,0,72.94,230.7Z",
    style: {
      fill: "#20E290",
      transformOrigin: "80.1943px 249.022px"
    },
    id: "el9jrydm0sflp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltk2232kcg2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.94,230.7c-3.84,2.05-8.39,31.12-2.66,35.82S92.82,254.3,92.82,254.3l-2.78-6s-10.27,8.67-12.89,7.2,0-9.69,0-9.69a29,29,0,0,0,0-8.54A9.68,9.68,0,0,0,72.94,230.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "80.1943px 249.022px"
    },
    className: "animable",
    id: "ellj8sh6id0t"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pipeline--inject-743",
    className: "animable",
    style: {
      transformOrigin: "269.445px 267.225px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.36,302.1c0,15.47-4.25,28-9.49,28H293.14c-5.25,0-9.5-12.55-9.5-28s4.25-28,9.5-28H413.87C419.11,274.08,423.36,286.62,423.36,302.1Z",
    style: {
      fill: "#20E290",
      transformOrigin: "353.5px 302.1px"
    },
    id: "elvmh0fc5s5qf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldrzmo0r6p99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.36,302.1c0,15.47-4.25,28-9.49,28H293.14c-5.25,0-9.5-12.55-9.5-28s4.25-28,9.5-28H413.87C419.11,274.08,423.36,286.62,423.36,302.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "353.5px 302.1px"
    },
    className: "animable",
    id: "elc36ipqjtes"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.5,271.38h-10c-6.15,0-11.13,13.65-11.13,30.5s5,30.49,11.13,30.49h10c6.14,0,11.12-13.65,11.12-30.49S309.64,271.38,303.5,271.38Z",
    style: {
      fill: "#20E290",
      transformOrigin: "298.495px 301.875px"
    },
    id: "elkjhrr4tmemb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbjnb38w1jfe"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.5,
    cy: 301.88,
    rx: 11.12,
    ry: 30.49,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "293.5px 301.88px"
    },
    className: "animable",
    id: "elmdco9rqto3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3dz3v2zo936"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.5,271.38h-10c-6.15,0-11.13,13.65-11.13,30.5s5,30.49,11.13,30.49h10c6.14,0,11.12-13.65,11.12-30.49S309.64,271.38,303.5,271.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "298.495px 301.875px"
    },
    className: "animable",
    id: "el9kcy2l5r1vn"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.5,271.38h-10c-6.15,0-11.13,13.65-11.13,30.5s5,30.49,11.13,30.49h10c6.14,0,11.12-13.65,11.12-30.49S297.64,271.38,291.5,271.38Z",
    style: {
      fill: "#20E290",
      transformOrigin: "286.495px 301.875px"
    },
    id: "el8imrpf1ntnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpnhvm6b9plb"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.5,
    cy: 301.88,
    rx: 11.12,
    ry: 30.49,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "281.5px 301.88px"
    },
    className: "animable",
    id: "elhsny7hlda6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrba0xy28r9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.5,271.38h-10c-6.15,0-11.13,13.65-11.13,30.5s5,30.49,11.13,30.49h10c6.14,0,11.12-13.65,11.12-30.49S297.64,271.38,291.5,271.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "286.495px 301.875px"
    },
    className: "animable",
    id: "elpgpconhygla"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.36,302.1c0,15.47-4.25,28-9.49,28H188.14c-5.25,0-9.5-12.55-9.5-28s4.25-28,9.5-28h90.73C284.11,274.08,288.36,286.62,288.36,302.1Z",
    style: {
      fill: "#20E290",
      transformOrigin: "233.5px 302.1px"
    },
    id: "elhkxcknk71sh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpk7jayw295m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.36,302.1c0,15.47-4.25,28-9.49,28H188.14c-5.25,0-9.5-12.55-9.5-28s4.25-28,9.5-28h90.73C284.11,274.08,288.36,286.62,288.36,302.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "233.5px 302.1px"
    },
    className: "animable",
    id: "elmadbwx978qb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.5,271.38h-10c-6.15,0-11.13,13.65-11.13,30.5s5,30.49,11.13,30.49h10c6.14,0,11.12-13.65,11.12-30.49S218.64,271.38,212.5,271.38Z",
    style: {
      fill: "#20E290",
      transformOrigin: "207.495px 301.875px"
    },
    id: "el3caqf11ejv4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpxb4nxyfz6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.5,
    cy: 301.88,
    rx: 11.12,
    ry: 30.49,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "202.5px 301.88px"
    },
    className: "animable",
    id: "elwfp10i76kcr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz6ex7yhr3lr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.5,271.38h-10c-6.15,0-11.13,13.65-11.13,30.5s5,30.49,11.13,30.49h10c6.14,0,11.12-13.65,11.12-30.49S218.64,271.38,212.5,271.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "207.495px 301.875px"
    },
    className: "animable",
    id: "eldwm6sa5yncd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.87,274.08H149.52v56h51.35c5.24,0,9.49-12.55,9.49-28S206.11,274.08,200.87,274.08Z",
    style: {
      fill: "#20E290",
      transformOrigin: "179.94px 302.08px"
    },
    id: "elj9ctgflb0qo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh7r042lin7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.87,274.08H149.52v56h51.35c5.24,0,9.49-12.55,9.49-28S206.11,274.08,200.87,274.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "179.94px 302.08px"
    },
    className: "animable",
    id: "elh8911c937o"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 137.77,
    y: 116.45,
    width: 56.04,
    height: 301.19,
    style: {
      fill: "#20E290",
      transformOrigin: "165.79px 267.045px"
    },
    id: "elh0lp61m12i4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli80n0so9iv"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.77,
    y: 116.45,
    width: 56.04,
    height: 301.19,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "165.79px 267.045px"
    },
    className: "animable",
    id: "elmbt395ii0d"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 344.32,
    width: 60.3,
    height: 10.68,
    rx: 1.4,
    style: {
      fill: "#20E290",
      transformOrigin: "165.79px 349.66px"
    },
    id: "elrrk6xnnmopj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 253.32,
    width: 60.3,
    height: 10.68,
    rx: 1.4,
    style: {
      fill: "#20E290",
      transformOrigin: "165.79px 258.66px"
    },
    id: "eljkrzyezdupr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.94 418 132.64 418 135.64 414.54 195.94 414.54 198.94 418",
    style: {
      fill: "#20E290",
      transformOrigin: "165.79px 416.27px"
    },
    id: "elsigp44uaesn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 195.32,
    width: 60.3,
    height: 20.68,
    rx: 1.4,
    style: {
      fill: "#20E290",
      transformOrigin: "165.79px 205.66px"
    },
    id: "elx2h533rsi1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmemptoicd9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 344.32,
    width: 60.3,
    height: 10.68,
    rx: 1.4,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "165.79px 349.66px"
    },
    className: "animable",
    id: "el52i94j9115m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elx8el4z8r7y"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 253.32,
    width: 60.3,
    height: 10.68,
    rx: 1.4,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "165.79px 258.66px"
    },
    className: "animable",
    id: "el9bdif735wx"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elesso0v341gf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.64,
    y: 195.32,
    width: 60.3,
    height: 20.68,
    rx: 1.4,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "165.79px 205.66px"
    },
    className: "animable",
    id: "elym0085i8nf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.75,198.31h-2.41c-1.48,0-2.68,3.29-2.68,7.35s1.2,7.35,2.68,7.35h2.41c1.49,0,2.69-3.29,2.69-7.35S139.24,198.31,137.75,198.31Z",
    style: {
      fill: "#20E290",
      transformOrigin: "136.55px 205.66px"
    },
    id: "elei80q35l5ab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb2r04513y9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.34,
    cy: 205.66,
    rx: 2.68,
    ry: 7.35,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "135.34px 205.66px"
    },
    className: "animable",
    id: "elpijsgyrxeg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4m3jlizvh6v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.75,198.31h-2.41c-1.48,0-2.68,3.29-2.68,7.35s1.2,7.35,2.68,7.35h2.41c1.49,0,2.69-3.29,2.69-7.35S139.24,198.31,137.75,198.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "136.55px 205.66px"
    },
    className: "animable",
    id: "elfy3b7ei50rg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134,203.35H122.46c-.76,0-1.38,1-1.38,2.31s.62,2.31,1.38,2.31H134c.76,0,1.37-1,1.37-2.31S134.73,203.35,134,203.35Z",
    style: {
      fill: "#20E290",
      transformOrigin: "128.225px 205.66px"
    },
    id: "elz8t3rpabeve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq2szk05jo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.83,205.66c0,1.27-.61,2.31-1.37,2.31s-1.38-1-1.38-2.31.62-2.31,1.38-2.31S123.83,204.39,123.83,205.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "122.455px 205.66px"
    },
    className: "animable",
    id: "els7jhge1s02g"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrzk9348alms"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134,203.35H122.46c-.76,0-1.38,1-1.38,2.31s.62,2.31,1.38,2.31H134c.76,0,1.37-1,1.37-2.31S134.73,203.35,134,203.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "128.225px 205.66px"
    },
    className: "animable",
    id: "el1qtwkzxev5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.17,199.37h4.18c2.57,0,4.65,2.82,4.65,6.29s-2.08,6.29-4.65,6.29h-4.18c-2.56,0-4.64-2.82-4.64-6.29S117.61,199.37,120.17,199.37Z",
    style: {
      fill: "#20E290",
      transformOrigin: "122.265px 205.66px"
    },
    id: "elhgrr3dwf8js",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltnrmpa94ow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.17,199.37h4.18c2.57,0,4.65,2.82,4.65,6.29s-2.08,6.29-4.65,6.29h-4.18c-2.56,0-4.64-2.82-4.64-6.29S117.61,199.37,120.17,199.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "122.265px 205.66px"
    },
    className: "animable",
    id: "elri0f4tpiquh"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfxt4io37yzi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.7,205.66c0,3.47,2.08,6.29,4.65,6.29s4.65-2.82,4.65-6.29-2.08-6.29-4.65-6.29S119.7,202.19,119.7,205.66Z",
    style: {
      opacity: 0.2,
      transformOrigin: "124.35px 205.66px"
    },
    className: "animable",
    id: "el67bglx5iq79"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.81,307.55h1.62c3.08,0,5.57-3.44,5.57-7.69s-2.49-7.69-5.57-7.69h-1.62c-3.08,0-5.57,3.45-5.57,7.69S300.73,307.55,303.81,307.55Z",
    style: {
      fill: "#20E290",
      transformOrigin: "304.62px 299.86px"
    },
    id: "elx1mjyup59z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldepockzzev"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.86,299.86c0-4.24,2.5-7.69,5.57-7.69s5.57,3.45,5.57,7.69-2.49,7.69-5.57,7.69S299.86,304.11,299.86,299.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "305.43px 299.86px"
    },
    className: "animable",
    id: "ele8h8ta94shh"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ele8lsnig9ovv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.81,307.55h1.62c3.08,0,5.57-3.44,5.57-7.69s-2.49-7.69-5.57-7.69h-1.62c-3.08,0-5.57,3.45-5.57,7.69S300.73,307.55,303.81,307.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "304.62px 299.86px"
    },
    className: "animable",
    id: "elkd48e08koj"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.26,284.92c-5.85,0-10.6,6.87-10.6,15.34s4.75,15.35,10.6,15.35,10.6-6.87,10.6-15.35S313.12,284.92,307.26,284.92ZM303,299.86h-4.29a18.22,18.22,0,0,1,1.74-7.53l3.11,5.69A4.37,4.37,0,0,0,303,299.86Zm0,1a4.17,4.17,0,0,0,.54,1.65l-3.11,5.69a18.19,18.19,0,0,1-1.74-7.34Zm4.69,0h8.16a18.22,18.22,0,0,1-1.76,7.42l-6.58-6.56A4.68,4.68,0,0,0,307.68,300.86Zm0-1a4.8,4.8,0,0,0-.19-1l6.58-6.57a18.26,18.26,0,0,1,1.77,7.61Zm5.89-8.52L307,297.85a2.69,2.69,0,0,0-.77-.77L307.65,287C310,287.12,312.08,288.79,313.58,291.34ZM306.64,287l-1.34,9.84a1.86,1.86,0,0,0-1.07.4L301,291.28C302.43,288.85,304.43,287.23,306.64,287ZM301,309.25l3.25-5.93a1.85,1.85,0,0,0,1.06.4l1.32,9.84C304.42,313.29,302.42,311.67,301,309.25Zm6.65,4.33-1.36-10.13a2.69,2.69,0,0,0,.77-.77l6.54,6.51C312.07,311.75,310,313.43,307.63,313.58Z",
    style: {
      fill: "#20E290",
      transformOrigin: "307.26px 300.265px"
    },
    id: "eljqsnbzibnj7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-743",
    className: "animable",
    style: {
      transformOrigin: "361.468px 337.096px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-743",
    className: "animable",
    style: {
      transformOrigin: "361.468px 337.096px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.85,294.67l-5.41-2.86a17.34,17.34,0,0,1-1.93-3.25c-.28-1-4-4.55-5.46-4.14s-5.07,7-3.71,7.91a32.68,32.68,0,0,0,6.26,2.6,12.37,12.37,0,0,0,2.3,0l5,4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "319.445px 291.659px"
    },
    id: "elc2d7vha3bv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.8,292.23s-17.18,6.41-19.11,6.46S324,291.21,324,291.21L320,296.57s11.51,10.08,14.28,12.23,26.07-3.09,26.07-3.09A15.49,15.49,0,0,0,357.8,292.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.459px 300.264px"
    },
    id: "el53c3dvlk0bg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el092fqpulxuw6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.8,292.23s-17.18,6.41-19.11,6.46S324,291.21,324,291.21L320,296.57s11.51,10.08,14.28,12.23,26.07-3.09,26.07-3.09A15.49,15.49,0,0,0,357.8,292.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "340.459px 300.264px"
    },
    className: "animable",
    id: "el7jk9p9c5tj4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "342.58 412.35 335.82 413.77 328.61 401.91 335.36 400.48 342.58 412.35",
    style: {
      fill: "rgb(228, 137, 123)",
      transformOrigin: "335.595px 407.125px"
    },
    id: "el5jovhur8lae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.46,410.91H342a.55.55,0,0,1,.53.43l1.23,5.54a.91.91,0,0,1-.71,1.09.65.65,0,0,1-.2,0c-2.45,0-4.23-.19-7.3-.19-1.89,0-7.6.2-10.21.2s-3-2.58-1.89-2.82c4.8-1,8.41-2.49,9.95-3.87A1.54,1.54,0,0,1,334.46,410.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.324px 414.445px"
    },
    id: "el5hrywb3h3xr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.4,412a1.87,1.87,0,0,1-1.19-.32.85.85,0,0,1-.31-.79.42.42,0,0,1,.25-.41c.69-.36,2.7.88,2.92,1a.12.12,0,0,1,.08.14.18.18,0,0,1-.12.13A8.11,8.11,0,0,1,332.4,412Zm-.92-1.29a.26.26,0,0,0-.19,0s-.09.05-.1.17a.62.62,0,0,0,.2.53,3,3,0,0,0,2.22.11A5.88,5.88,0,0,0,331.48,410.72Z",
    style: {
      fill: "#20E290",
      transformOrigin: "332.522px 411.21px"
    },
    id: "elex5vgwxctia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,411.79h-.07c-.64-.35-1.88-1.72-1.75-2.38a.47.47,0,0,1,.47-.39.8.8,0,0,1,.63.19c.72.59.87,2.38.88,2.46a.16.16,0,0,1-.08.14Zm-1.25-2.53h-.07c-.19,0-.2.11-.21.15-.08.4.71,1.44,1.35,1.92a3.51,3.51,0,0,0-.73-1.94A.53.53,0,0,0,332.74,409.26Z",
    style: {
      fill: "#20E290",
      transformOrigin: "333.165px 410.412px"
    },
    id: "eloqh8ey91poe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el443pnm0yqud"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "335.36 400.48 328.61 401.91 332.33 408.03 339.09 406.6 335.36 400.48",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "333.85px 404.255px"
    },
    className: "animable",
    id: "elkin04pc1y9e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.9,372.15c-.36,0-4.47,0-4.85-.07a110.33,110.33,0,0,1-21.82-4.48c-6.37-1.91-10.77-3.7-10.77-3.7-1.45,8.44,12.24,40.82,12.24,40.82l-11.18.69s-31.28-46.13-17.95-60.51c9.95-10.73,36.95.92,36.95.92l7.05-14.89,29.89,1.71S390.92,373.54,364.9,372.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.217px 368.17px"
    },
    id: "eltb763aw1k59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.04 406.74 340.19 404.95 339.12 401.92 326.99 404.45 329.04 406.74",
    style: {
      fill: "#20E290",
      transformOrigin: "333.59px 404.33px"
    },
    id: "eld5swvuf836n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.31 399.69 418.9 405.89 404.59 407.75 404.01 401.55 418.31 399.69",
    style: {
      fill: "rgb(228, 137, 123)",
      transformOrigin: "411.455px 403.72px"
    },
    id: "elrtu4o43sow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.26,406.82l-.71-7.53a.56.56,0,0,1,.38-.57l5.4-1.74a.92.92,0,0,1,1.15.6,1.42,1.42,0,0,1,0,.2c.19,2.44.21,4.23.49,7.29.18,1.88.91,7.55,1.16,10.15s-2.29,3.18-2.63,2.14c-1.49-4.68-3.27-8.14-4.79-9.54A1.54,1.54,0,0,1,418.26,406.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "421.848px 407.393px"
    },
    id: "ele5bzaxpuks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.54,408.76a1.84,1.84,0,0,1-.2,1.22.86.86,0,0,1-.76.38.42.42,0,0,1-.43-.21c-.42-.65.62-2.77.74-3a.14.14,0,0,1,.13-.09.14.14,0,0,1,.14.1A7.45,7.45,0,0,1,419.54,408.76Zm-1.2,1.05a.3.3,0,0,0,.06.18s.06.08.18.08a.61.61,0,0,0,.51-.25,3,3,0,0,0-.09-2.21A6,6,0,0,0,418.34,409.81Z",
    style: {
      fill: "#20E290",
      transformOrigin: "418.81px 408.712px"
    },
    id: "elh0k0k6aa5a8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.17,407.2v.07c-.29.67-1.54,2-2.2,2a.47.47,0,0,1-.43-.43.76.76,0,0,1,.13-.64c.51-.78,2.28-1.09,2.37-1.11a.16.16,0,0,1,.14.06A.11.11,0,0,1,419.17,407.2Zm-2.4,1.48v.07c0,.19.13.2.17.2.41,0,1.37-.84,1.79-1.53a3.52,3.52,0,0,0-1.87.92A.52.52,0,0,0,416.77,408.68Z",
    style: {
      fill: "#20E290",
      transformOrigin: "417.849px 408.18px"
    },
    id: "elbrmdhckxye9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eledb4fbrrcd5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "404.02 401.55 404.6 407.75 411.98 406.79 411.39 400.58 404.02 401.55",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "408px 404.165px"
    },
    className: "animable",
    id: "ellbdbxe0ft5q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.64,409.38s-40.35,11.8-50.4,4.68c-4.94-3.5-6.83-12.36-7.12-22.42a138.79,138.79,0,0,1,1.09-20.44c1.31-10.84,3.39-19.75,4.3-21.09,0,0,27-.75,26.26,6s-15.14,41.53-12,44.29,37.15-1.32,37.15-1.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.865px 383.215px"
    },
    id: "el8yg652uxhbq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.52 398.28 408.35 410.72 411.47 409.93 410.06 397.62 407.52 398.28",
    style: {
      fill: "#20E290",
      transformOrigin: "409.495px 404.17px"
    },
    id: "ellhaqpbfwf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3mzlthxntd4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "329.04 406.74 340.19 404.95 339.12 401.92 326.99 404.45 329.04 406.74",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "333.59px 404.33px"
    },
    className: "animable",
    id: "elisl4oteon5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcvnhwkyf24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "407.52 398.28 408.35 410.72 411.47 409.93 410.06 397.62 407.52 398.28",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "409.495px 404.17px"
    },
    className: "animable",
    id: "elkhalfd5rrke"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.39,277.41c.15.49-.07,1-.39,1s-.68-.28-.79-.77.07-1,.39-1S341.29,276.94,341.39,277.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.808px 277.525px"
    },
    id: "eljexhswj481j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.89,277.78a18,18,0,0,1-1.46,4.8,3,3,0,0,0,2.51-.07Z",
    style: {
      fill: "rgb(137, 43, 41)",
      transformOrigin: "341.685px 280.301px"
    },
    id: "el7eh73hucs7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.15,274.64h0a.3.3,0,0,0-.2.37.27.27,0,0,0,.13.13.34.34,0,0,0,.24.09,2.43,2.43,0,0,1,2.15.35.3.3,0,0,0,.42,0h0a.3.3,0,0,0,0-.42A3,3,0,0,0,340.15,274.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "341.457px 275.088px"
    },
    id: "elst1jrj010b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.44,284.75q.24.42.51.81a9,9,0,0,0,4.19,3.27,7.68,7.68,0,0,0,1.32.39,8.11,8.11,0,0,0,6.83-1.52,8.28,8.28,0,0,0,2.09-2.48c2.27-4,1.2-7.61-.11-13.86a8.74,8.74,0,0,0-13.93-5.28C339,270.17,340.61,279.56,343.44,284.75Z",
    style: {
      fill: "rgb(185, 121, 100)",
      transformOrigin: "350.261px 276.842px"
    },
    id: "ele6aimpq5ckn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0uonzma1zlg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.14,288.83a7.68,7.68,0,0,0,1.32.39,8.11,8.11,0,0,0,6.83-1.52,9.69,9.69,0,0,0-1.67-1.79A12.57,12.57,0,0,0,348.14,288.83Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "352.215px 287.669px"
    },
    className: "animable",
    id: "eli7g47bgmzcl"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.7,293.47c-2.29,3.58-10,4.57-10,4.57s-5,0-4.4-1.73c2.61-1.19,3.59-2.82,3.69-4.6a8.32,8.32,0,0,0-.56-3.2c-.2-.57-.45-1.13-.7-1.68l7.35-9.29C358.09,282.36,358.85,291,362.7,293.47Z",
    style: {
      fill: "rgb(185, 121, 100)",
      transformOrigin: "355.475px 287.79px"
    },
    id: "elyeoibyubuum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.25,263.48c1.42-1.12,5.68-3.14,8.62-3.14,9.11,0,9.4,5.24,9.4,5.24a6.14,6.14,0,0,0-2.83-1.79c9.9,9.24.91,20.62.91,20.62-3.81-.67-8,1.66-8,1.66s-2.42-5.34-4.4-6.75A11,11,0,0,1,343,272c0-2.28-1.89-.72-1.89-.72C339.2,270.22,341.17,265.13,343.25,263.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "351.712px 273.205px"
    },
    id: "eldn8vdtyxm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.9,277.73a4.16,4.16,0,0,1-1.31,3.29c-1.11.87-2.41-.67-2.73-2.57-.27-1.69-.05-4.23,1.38-4.29S348.89,276,348.9,277.73Z",
    style: {
      fill: "rgb(185, 121, 100)",
      transformOrigin: "346.834px 277.714px"
    },
    id: "el2botmvhnxkk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.82,269.09s-.29,14.5,2.79,19c0,0-3.88-2.71-3.84-18.33Z",
    id: "elvdwbxv1km3",
    className: "animable",
    style: {
      transformOrigin: "344.69px 278.59px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.14,267.24s5.44,5.28,9.53,6.27,5.56-1.46,5.56-1.46l-.53-4.4s.11,3.39-1.54,3.73-5.44-.41-9.94-4.78Z",
    style: {
      fill: "#20E290",
      transformOrigin: "355.685px 270.173px"
    },
    id: "eljftmlso8xg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqbmbck6w5nh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.14,267.24s5.44,5.28,9.53,6.27,5.56-1.46,5.56-1.46l-.53-4.4s.11,3.39-1.54,3.73-5.44-.41-9.94-4.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "355.685px 270.173px"
    },
    className: "animable",
    id: "eltxnhzlh68nl"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339,271.69s-.53-6.43,2-9.43,9.75-4.65,14.43-3.54,7.23,7.15,7.42,8.38c.43,2.86-10.26-2.18-16.32.09S339,271.69,339,271.69Z",
    style: {
      fill: "#20E290",
      transformOrigin: "350.908px 265.031px"
    },
    id: "elbkxpiwrmjds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyu62oetd0og"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339,271.69s-.53-6.43,2-9.43,9.75-4.65,14.43-3.54,7.23,7.15,7.42,8.38c.43,2.86-10.26-2.18-16.32.09S339,271.69,339,271.69Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "350.908px 265.031px"
    },
    className: "animable",
    id: "eln5tymhjlx2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.78,261.47s.37-3.19,1.37-4,9.34-1.85,11.85-.84,6.32,5.51,7.05,10.84L358,268s-1.33-6-4.94-7.72C348.91,258.36,341.78,261.47,341.78,261.47Z",
    style: {
      fill: "#20E290",
      transformOrigin: "351.915px 262.106px"
    },
    id: "elnpje934aqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.06,274.93s3.28.77,5.9-3.26,8.28-4.32,12.76-3.31a28.55,28.55,0,0,0,9.67.5l-2.57-1.76s-3.28.77-9-1-13.23,2.08-14.8,5.59Z",
    style: {
      fill: "#20E290",
      transformOrigin: "351.225px 270.322px"
    },
    id: "el3m2az1jnfok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07,333.67l-34.81,5.61c-.58-8.14-1.57-15.93-2.69-22.91-.12-.82-.26-1.62-.39-2.41-.29-1.73-.71-3.71-1.19-5.75-1.19-5.1-2.72-10.61-3.41-13.67,0,0,12.89-4.67,23.15-2.07C377.86,295.54,385.07,333.67,385.07,333.67Z",
    style: {
      fill: "#20E290",
      transformOrigin: "363.825px 315.481px"
    },
    id: "elm0xl369byx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldtc4yadct4c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.26,364.71c-.23.78-7.57,24.79-23.14,26.93a138.79,138.79,0,0,1,1.09-20.44,73.47,73.47,0,0,0,10.61.94C367.66,372,374.26,367.28,375.26,364.71Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "363.675px 378.175px"
    },
    className: "animable",
    id: "elwva7rcj2pgf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp9353k55ke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.1,329.13l-34.19,5.95c-.13-1.61-.29-3.21-.47-4.79l15.27-3c-1-4.93-3-13.86-5.85-20.52a38.13,38.13,0,0,0-10.44-13.82q.9-.21,1.89-.39c10.63,8,16,26.33,17.86,34.05l9.66-1.92c-.85-4.51-3-14.52-6.1-21.82a36.94,36.94,0,0,0-7-10.61c.35.07.7.15,1,.24a7.94,7.94,0,0,1,2.56,1.2c7.85,9.71,11.79,24.67,13.06,30.29l1.4-.27C383.3,325.74,383.74,327.59,384.1,329.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "366.26px 313.67px"
    },
    className: "animable",
    id: "el7nh6ywwa6sk"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7du1k1s7oia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.57,316.37c-.12-.82-.26-1.62-.39-2.41-.29-1.73-.71-3.71-1.19-5.75a7.56,7.56,0,0,1,2.91-1.61S349.91,312.69,347.57,316.37Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "347.553px 311.485px"
    },
    className: "animable",
    id: "elfskrn48tmu9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.87,312.37l-6.08-.67a17.19,17.19,0,0,1-3-2.32c-.63-.82-5.37-2.76-6.6-1.84s-2.15,8.37-.54,8.72a32.71,32.71,0,0,0,6.77.12,12.3,12.3,0,0,0,2.13-.87l6.14,1.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.329px 312.324px"
    },
    id: "el9xiscn0rruj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.76,295.44s-17.55,15.93-19.33,16.68-16.38-1.57-16.38-1.57L307.26,317s14.41,5.14,17.77,6.13,23.11-12.46,23.11-12.46S351.82,300,344.76,295.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.179px 309.311px"
    },
    id: "elmadg8j622ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7pbyrqt1xrt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.76,295.44s-17.55,15.93-19.33,16.68-16.38-1.57-16.38-1.57L307.26,317s14.41,5.14,17.77,6.13,23.11-12.46,23.11-12.46S351.82,300,344.76,295.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "328.179px 309.311px"
    },
    className: "animable",
    id: "eldy2rbcjo6rr"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiJobRunningAnimation);
export default __webpack_public_path__ + "static/media/ai_job_running_animation.f6dd42cc1030a4a1a78ed3fdf9c61fd5.svg";
export { ForwardRef as ReactComponent };